export const gbpMarket = ['GB', 'GG', 'IM', 'JE']
export const usdMarket = [
  'BD',
  'BB',
  'BO',
  'BR',
  'VG',
  'CA',
  'KY',
  'CL',
  'CN',
  'CO',
  'CR',
  'CI',
  'DO',
  'EC',
  'EG',
  'SV',
  'ET',
  'FJ',
  'GH',
  'GT',
  'HN',
  'HK',
  'IN',
  'ID',
  'JM',
  'JP',
  'KE',
  'MY',
  'MX',
  'MA',
  'NZ',
  'NI',
  'NG',
  'PK',
  'PA',
  'PG',
  'PY',
  'PE',
  'PH',
  'SN',
  'SG',
  'SB',
  'ZA',
  'KR',
  'TW',
  'TZ',
  'TH',
  'TT',
  'UG',
  'US',
  'UY',
  'VN',
  'ZM',
  'ZW',
]
